export default __webpack_public_path__ + "static/media/Conscript's Vambraces of Heaven's Pass.39f33203.jpg";